import { observable, action, computed, autorun, makeObservable } from "mobx";

class TitleStore {
  defaultTitle: string = "";
  projectName: string = "";
  pageName: string = "";

  constructor() {
    makeObservable(this, {
      defaultTitle: observable,
      projectName: observable,
      pageName: observable,
      setProjectName: action.bound,
      setPageName: action.bound,
      fullTitle: computed,
    });

    this.defaultTitle = "PMG";
    this.projectName = "";
    this.pageName = "";
  }

  setProjectName(name: string) {
    this.projectName = name;
  }

  setDefaultTitle(name: string) {
    if (name) {
      this.defaultTitle = name;
    }
  }

  setPageName(name: string) {
    this.pageName = name;
  }

  get fullTitle() {
    const { pageName, projectName, defaultTitle } = this;
    const pageTitle = [pageName, projectName, defaultTitle].filter(Boolean);

    return pageTitle.join(" | ");
  }
}

const titleStore = new TitleStore();

autorun(
  () => {
    // console.log("autorun titleStore.", titleStore.fullTitle);
    document.title = titleStore.fullTitle;
  },
  { delay: 300 }
);

export { titleStore };
